import { FulfillmentGroupDataSchema } from "@redotech/redo-model/fulfillments/fulfillment-group";
import * as z from "zod";
import { null as zNull } from "zod";
export const getMergeSuggestions = {
  name: "getMergeSuggestions" as const,
  input: zNull(),
  output: z.object({
    suggestions: z.record(z.string(), z.array(FulfillmentGroupDataSchema)),
  }),
};
